import React ,{useEffect , useState} from 'react'
import { NavLink } from 'react-router-dom'
import Blogarea from '../Blogarea'
import Ctaarea from '../Ctaarea'
import Teamarea from '../Teamarea'
import Key_Feature from './Key_Feasures/Key_Feature'
import Aboute_Area from './Key_Feasures/Aboute_Area'
import Counter_Area from './Key_Feasures/Counter_Area'
import { BASE_URL } from '../Config/Config'
import SubLoading from '../ALL CSS/Loading'

function About() {

  const [bannerData , setBannerImage] = useState([]);
  const [bannerLoading , setBannerLoading] = useState(true);
  useEffect(() => {
    const fetchBannerImage = async () => {
      try {
        setBannerLoading(true);
        const response = await fetch(`${BASE_URL}/banner/?page=About-us`);
        const result = await response.json();
        setBannerImage(result.data[0]);
            } catch (error) {
              console.error('Error fetching banner:', error);
            } finally {
              setBannerLoading(false);
            }
          };
          
          fetchBannerImage();
        }, []);
  return (
   <>
        {bannerLoading && bannerData && bannerData.image  ? ( 
          <SubLoading/>
        ):(

   <div className="breadcumb-wrapper "   
      style={{
       backgroundImage: `url(${BASE_URL}${bannerData.image})`,
       backgroundSize: 'contain',
       backgroundPosition: 'center',
     }}
    data-overlay="title" data-opacity={8} >
  <div className="breadcumb-shape" data-bg-src="assets/img/bg/breadcumb_shape_1_1.png">
  </div>
  <div className="shape-mockup breadcumb-shape2 jump d-lg-block d-none" data-right="30px" data-bottom="30px">
    <img src="assets/img/bg/breadcumb_shape_1_2.png" alt="shape"/>
  </div>
  <div className="shape-mockup breadcumb-shape3 jump-reverse d-lg-block d-none" data-left="50px" data-bottom="80px">
    <img src="/assets/img/bg/breadcumb_shape_1_3.png" alt="shape"/>
  </div>
  <div className="container">
    <div className="breadcumb-content text-center">
      <h1 className="breadcumb-title">About Us</h1>
      <ul className="breadcumb-menu">
        <li><NavLink to="/">Home</NavLink></li>
        <li>About Us</li>
      </ul>
    </div>
  </div>
   </div>


)}
{/* Service Area   */}

<Key_Feature/>

{/* About Area   */}

<Aboute_Area/>

<Counter_Area/>

{/* Team Area   */}
<Teamarea/>
  

     
{/* <section className="cta-area-3">
  <div className="container">
    <div className="row">
      <div className="col-lg-6 mb-30 mb-lg-0">
        <div className="cta-card" data-bg-src="assets/img/bg/cta-bg_3_1.png">
          <div className="title-area mb-40">
            <span className="sub-title text-white"><i className="fal fa-book me-2" />Popular Courses</span>
            <h4 className="sec-title text-white">Get The Best Courses &amp; <br /> Upgrade Your Skills </h4>
          </div>
          <NavLink to="/contact" className="th-btn style8">Join With Us<i className="fas fa-arrow-right ms-2" /></NavLink>
        </div>
      </div>
      <div className="col-lg-6">
        <div className="cta-card" data-bg-src="assets/img/bg/cta-bg_3_2.png">
          <div className="title-area mb-40">
            <span className="sub-title text-white"><i className="fal fa-book me-2" />Popular Courses</span>
            <h4 className="sec-title text-white">Engaging Courses for <br /> Intellectual Exploration</h4>
          </div>
          <NavLink to="/contact" className="th-btn style8">Join With Us<i className="fas fa-arrow-right ms-2" /></NavLink>
        </div>
      </div>
    </div>
  </div>

</section> */}

{/* Blog Area   */}

<Blogarea/> 

{/* Cta Area   */}
  
 <Ctaarea/>
 
   </>
  )
}

export default About